export var textBlack = 'rgba(28, 38, 57, 1)';
export var white = 'rgba(255, 255, 255, 1)';
export var contrastColor = 'rgba(214, 219, 230, 1)';
export var accentColor = 'rgba(235, 5, 5, 1)';
export var accentSolid = 'rgba(213, 0, 0, 1)';
export var nonActiveText = 'rgba(187, 193, 204, 1)';
export var linkText = 'rgba(64, 131, 216, 1)';
export var shadowColor = 'rgba(70, 90, 136, 0.2)';
export var lightBack = 'rgba(247, 248, 250, 1)';
export var blueGragient = '135deg, #3ab0db 0%, #465cd6 100%';
export var blueGragient1 = '180deg, #3ab0db 0%, #465cd6 100%';
export var lightPrimary = 'rgba(97, 184, 242, 1)';
export var mainPrimary = 'rgba(64, 131, 216, 1)';
export var darkPrimary = 'rgba(38, 79, 191, 1)';
export var lightSecondary = 'rgba(240, 60, 24, 1)';
export var mainSecondary = 'rgba(213, 0, 0, 1)';
export var darkSecondary = 'rgba(176, 0, 29, 1)';
export var lightError = 'rgba(255, 72, 36, 1)';
export var mainError = 'rgba(235, 5, 5, 1)';
export var darkError = 'rgba(196, 0, 33, 1)';
export var lightWarning = 'rgba(255, 161, 50, 1)';
export var mainWarning = 'rgba(255, 122, 0, 1)';
export var darkWarning = 'rgba(217, 69, 0, 1)';
export var lightInfo = 'rgba(97, 184, 242, 1)';
export var mainInfo = 'rgba(64, 131, 216, 1)';
export var darkInfo = 'rgba(38, 79, 191, 1)';
export var lightSuccess = 'rgba(44, 224, 105, 1)';
export var mainSuccess = 'rgba(0, 199, 92, 1)';
export var darkSuccess = 'rgba(0, 148, 94, 1)';
export var contrastBg = 'rgba(227, 231, 239, 1)';
